import React from 'react'

const About = () => {
  return (
    <div name="about" className='w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white'>
        <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
            <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-gray-500'>
                    About 
                </p>
            </div>
            <p className='text-2xl mt-20'>
            I am a Pre Final Year Information Technology Student from Sinhgad College Of Engineering, Pune. I love exploring new technologies and often amazed by the progress we as a human species have mad so far in the recent years!
            </p>
            <br />
            <p className='text-2xl'>
            I often practice ,Data Structure & Algorithm on platforms like GeeksforGeeks, Leetcode. I am intersted in Web Development exploring the power of JavaScript. I am also enthusiastic about Cloud Computing.
            </p>
        </div>
    </div>
  )
}

export default About